import React from "react";

import nextArrowIcon from "../../../../assets/icons/arrows/chevron-right.svg";
import prevArrowIcon from "../../../../assets/icons/arrows/chevron-left.svg";

const arrows = {
  next: nextArrowIcon,
  prev: prevArrowIcon,
};

const navArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={[className].join(" ")}
      style={{
        ...style,
      }}
      onClick={onClick}
    >
      <img alt={props.arrowValue} src={arrows[props.arrowValue]} />
    </div>
  );
};

export default navArrow;
